import React, { ReactElement } from "react";
import { CircleLogo } from "web/react/emo/circle-logo";
import { HStack } from "web/react/emo/h-stack";
import { VStack } from "web/react/emo/v-stack";
import { LabelledRow } from "web/react/pages/account/order-history/labelled-row";
import { gettext } from "web/script/modules/django-i18n";
import { RetailerOrderHistorySerializer } from "web/types/serializers";

export function RetailerOrderCard({
    retailerOrder,
}: {
    retailerOrder: RetailerOrderHistorySerializer;
}): ReactElement {
    return (
        <HStack spacing="sm" align="center">
            <CircleLogo
                size="lg"
                name={retailerOrder.retailer_name}
                imageURL={retailerOrder.retailer_image || undefined}
            />
            <VStack spacing="xxxs">
                <LabelledRow
                    label={gettext("order_history.orders.name")}
                    value={retailerOrder.retailer_name}
                />
                {retailerOrder.order_no && (
                    <LabelledRow
                        label={gettext("order_history.orders.retailer_order_no")}
                        value={retailerOrder.order_no}
                    />
                )}
                <LabelledRow
                    label={gettext("order_history.orders.items")}
                    value={retailerOrder.items_count}
                />
                <LabelledRow
                    label={gettext("order_history.orders.total")}
                    value={retailerOrder.total_amount}
                />
            </VStack>
        </HStack>
    );
}
